import user from '../../../helpers/user-info';
import { MARKETO_GA_GUID_FIELD_NAME, getGaGuidAsync } from '../form/fields/field-ga-guid';

const mktoSetup = {
  fixSelectFlicker(form) {
    const selEls = form.getFormElem()[0].querySelectorAll('select');
    if (window.chrome && window.chrome.runtime && navigator.credentials) { // Chrome 51+
      [].forEach.call(selEls, (el) => {
        el.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });
    }
  },

  disableDefaultStyles(form) {
    const formEls = form.getFormElem()[0];
    formEls.removeAttribute('style');
    for (let elsWithStyles = formEls.querySelectorAll('[style]'), i = 0, imax = elsWithStyles.length; i < imax; i++) {
      elsWithStyles[i].removeAttribute('style');
    }
    if (document.getElementById('mktoForms2BaseStyle')) {
      document.getElementById('mktoForms2BaseStyle').remove();
    }

    if (document.getElementById('mktoForms2ThemeStyle')) {
      document.getElementById('mktoForms2ThemeStyle').remove();
    }
  },

  disableFirstOption(form) {
    const formEls = form.getFormElem();
    formEls.find('select option:first-child').prop('disabled', true);
  },

  /**
   * Should be kept in sync with field-business-type-category.js 
   */
  setBusinessCategoryPlaceholder(form, businessVertical) {
    let placeholder = '';
    if (businessVertical === 'Quick-Serve') {
      placeholder = 'What type of quick-serve business are you?';
    }
    else if (businessVertical === 'Retail') {
      placeholder = 'What type of retailer are you?';
    }
    if (placeholder) {
      const placeholderElement = form.getFormElem()[0].querySelector('#Business_Category_Type__c option[disabled]');
      if (placeholderElement) {
        placeholderElement.innerText = placeholder;
      }
    }
  },

  setPlaceholderColors(form) {
    const formEls = form.getFormElem();
    const selEls = formEls.find('select');
    let selectColor;

    selEls.on('change', function() {
      //selectColor = (this.value === '') ? '#BABFC6' : '#7a7a7a';
      selectColor = (this.value === '') ? '#dddfe1' : '#525E71';
      return this.setAttribute('style', `color: ${selectColor}`);
    });
  },

  setUserTimezone(form) {
    if (form.getFormElem().find('input[name="Timezone__c"]')) {
      const timezone = `${user.timezone.name} (${user.timezone.location}, ${user.timezone.offset})`;
      form.vals({ Timezone__c: timezone });
    }
  },

  setUserDevice(form) {
    if (form.getFormElem().find('input[name="User_Agent__c"]')) {
      const userdevice = `
        browser: ${user.browser.name},
        browserVersion: ${user.browser.version},
        browserEngine: ${user.browser.engine},
        device: ${user.device.name},
        deviceType: ${user.device.type},
        os: ${user.os.name},
        osVersion: ${user.os.version},
        userAgent: ${user.agent}
      `;
      form.vals({ User_Agent__c: userdevice });
    }
  },

  setLeadSubmissionUrl(form) {
    if (form.getFormElem().find('input[name="Lead_Submission_URL__c"]')) {
      form.vals({ Lead_Submission_URL__c: window.location.host + window.location.pathname });
    }
  },

  setGaGuid(form){
    getGaGuidAsync((gaGuid)=>{
      form.vals({ [MARKETO_GA_GUID_FIELD_NAME]: gaGuid });
    });
  },

  isEmailValid(email) {
    const invalidEmails = [
      'none@none.com',
      'noemail@noemail.com',
      'none@gmail.com',
      'none@yahoo.com',
      'none@hotmail.com',
      'none@aol.com',
      'noemail@gmail.com',
      'noemail@yahoo.com',
      'noemail@hotmail.com',
      'noemail@aol.com',
      'na@na.com',
      'no@no.com',
      'no@none.com',
      'example@yourdomain.com',
    ];
    for (let i = 0; i < invalidEmails.length; i++) {
      const domain = invalidEmails[i];
      if (email.indexOf(domain) !== -1) {
        return false;
      }
    }

    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+[^.]\.[A-Z]{2,}$/i.test(email);
  },

  validateEmail(form) {
    form.onValidate(() => {
      const email = form.vals().Email;
      if (email) {
        if (!mktoSetup.isEmailValid(email)) {
          form.submitable(false);
          const emailElem = form.getFormElem().find('#Email');
          form.showErrorMessage('Must be a valid email', emailElem);
          if (emailElem.offset().top - window.pageYOffset < 40) {
            window.scrollTo(0, emailElem.offset().top - 100);
          }
        } else {
          form.submitable(true);
        }
      }
    });
  },
};

export default mktoSetup;
